import { render } from "./birthday-icon.svg?vue&type=template&id=66e1195b"
import script from "./birthday-icon.svg?vue&type=script&lang=js"
export * from "./birthday-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4103/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__